module.exports = __webpack_public_path__ + "img/videos_icon.6912b25a.svg";